import React from "react"

export default function hero({ children, hero, title }) {
  return (
      <div className={hero}>
      <div className="banner-content">
        <h1>{title}</h1>
        {children}
      </div>
    </div>
  )
}
